import { createRouter, createWebHistory } from "vue-router";
import Signin from "../views/Signin.vue";
import Signup from "../views/Signup.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Profile from "../views/Profile.vue";

import Plans from "../views/Plans.vue";
import Plan from "../views/Plan.vue";
import FileAClaim from "../views/FileAClaim.vue";
import PasswordReset from "../views/PasswordReset.vue";
import Subscription from "../views/Subscription.vue";
import SubscriptionPublic from "../views/SubscriptionPublic.vue";
import Cancellation from "../views/Cancellation.vue";
import PaymentMethods from "../views/PaymentMethods.vue";

import store from "../store";
import Claim from "@/views/Claim.vue";
import SubscriptionSuccess from "../views/SubscriptionSuccess.vue";
import UnsubscribeSuccess from "../views/UnsubscribeSuccess.vue";
import Claims from "@/views/Claims.vue";
import Invoices from "@/views/Invoices.vue";
import RedirectToStripe from "@/views/claim/payment/RedirectToStripe.vue";
import { NotFound } from "@estaly/ui";
import NewDeclarationVersion from "@/views/claim/NewDeclarationVersion.vue";
import MagicSignin from "../views/MagicSignin.vue";

const publicRoutes = [
  {
    path: "/signin",
    component: Signin,
  },

  {
    path: "/signup",
    component: Signup,
  },

  {
    path: "/forgot-password",
    component: ForgotPassword,
  },

  {
    path: "/password-reset/:id",
    component: PasswordReset,
  },

  {
    path: "/magic-signin/:token",
    component: MagicSignin,
  },

  {
    path: "/subscription/:uniqueToken",
    component: Subscription,
  },

  {
    path: "/:storeShop/subscription",
    component: SubscriptionPublic,
  },

  {
    path: "/subscription/success",
    component: SubscriptionSuccess,
  },

  {
    path: "/claims/payment",
    component: RedirectToStripe,
  },
  {
    path: "/unsubscribe/success",
    component: UnsubscribeSuccess,
  },
  {
    path: "/404",
    component: NotFound,
  },
];

const customerRoutes = [
  {
    path: "/plans",
    component: Plans,
    meta: { layout: "customer-layout", navigation: "Contracts" },
  },

  {
    path: "/plans/:id",
    component: Plan,
    meta: { layout: "customer-layout", navigation: "Contracts" },
  },

  {
    path: "/file-claim",
    component: FileAClaim,
    meta: { layout: "customer-layout", navigation: "File a claim" },
  },

  {
    path: "/claims",
    component: Claims,
    meta: { layout: "customer-layout", navigation: "Claim List" },
  },

  {
    path: "/claims/:id",
    component: Claim,
    meta: { layout: "customer-layout", navigation: "Claim List" },
  },
  {
    path: "/claims/:id/declarations/new-version",
    component: NewDeclarationVersion,
    meta: { layout: "customer-layout", navigation: "Claim List" },
  },
  {
    path: "/plans/:id/claim",
    component: FileAClaim,
    meta: { layout: "customer-layout", navigation: "Claim List" },
  },

  {
    path: "/plans/:id/cancellation",
    component: Cancellation,
    meta: { layout: "customer-layout", navigation: "Plans" },
  },

  {
    path: "/account",
    component: Profile,
    meta: { layout: "customer-layout", navigation: "Account" },
  },

  {
    path: "/invoices",
    component: Invoices,
    meta: { layout: "customer-layout", navigation: "Invoices" },
  },

  {
    path: "/payment-methods",
    component: PaymentMethods,
    meta: { layout: "customer-layout", navigation: "Payment Methods" },
  },
];

function needsHttpsRedirection() {
  return (
    (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "demo" || process.env.NODE_ENV === "staging") &&
    location.protocol !== "https:"
  );
}

function redirectHttps() {
  location.replace(`https:${location.href.substring(location.protocol.length)}`);
}

function hasPermission(to, userPermissions) {
  return to.meta.permission ? userPermissions.includes(to.meta.permission) : true;
}

function redirectToDefaultRoute(next) {
  if (store.getters["auth/isCustomer"]) {
    next("/plans");
  } else {
    next("/signin");
  }
}

const routes = publicRoutes.concat(customerRoutes);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (needsHttpsRedirection()) {
    redirectHttps();
  } else {
    const publicPages = publicRoutes.map((route) => route.path);
    const authRequired = !to.matched.some((matched) => publicPages.includes(matched.path));
    const signedIn = store.state.auth.signedIn;

    // remove isLoading
    store.state.customer.isLoading = false;

    if (!authRequired) {
      // Public routes
      next();
      return;
    }

    if (!signedIn || store.state.auth.currentUser.permissions === undefined) {
      next("/signin");
    } else {
      if (to.path === "/") {
        // Default route
        redirectToDefaultRoute(next);
      } else {
        if (!hasPermission(to, store.state.auth.currentUser.permissions)) {
          next(from.path);
        } else {
          if (!to.matched.length) {
            next("/404");
          } else {
            next();
          }
        }
      }
    }
  }
});

router;

export default router;
